import caseApiService from '@/services/caseApiService';

const getAgreements = function ({ commit }) {
  return caseApiService.getAgreements().then(res => {
    commit('SET_AGREEMENTS', res.data);
  })
};

const getCase = ({ commit }, key) => {
  return caseApiService.getCase(key)
    .then((res) => {
      commit('SET_CASE', res.data);
      return res;
    });
};

const getCaseByBookedOfferKey = ({ commit }, key) => {
  return caseApiService.getCaseByBookedOfferKey(key)
    .then((res) => {
      res.data.serviceCase.messageAccessToken = res.data.messageAccessToken;
      commit('SET_CASE', res.data.serviceCase);
      return res;
    });
};

const getCaseByToken = ({ commit }, token) => {
  return caseApiService.getCaseByToken(token)
    .then((res) => {
      res.data.messageAccessToken = token;
      commit('SET_CASE', res.data);
      return res;
    });
};

export default {
  getAgreements,
  getCase,
  getCaseByBookedOfferKey,
  getCaseByToken
};
